import { useStores } from 'src/models';

/**
 * 수정 권한이 있는 부서 SID 목록
 * 3010: 경영지원실
 * 3011: 서비스개발팀
 */
const ALLOWED_DEPT_SIDS = [3010, 3011];

/**
 * 자리배치도 수정 권한 체크 Hook
 */
export const useEditPermission = (): boolean => {
  const { authStore } = useStores();
  const userDeptSid = authStore.user?.deptSid;

  if (!userDeptSid) return false;

  return ALLOWED_DEPT_SIDS.includes(userDeptSid);
};
